export default __webpack_public_path__ + "static/media/logo.5b4e652a.svg";